export const WASHER_SUCCESS = 'WASHER_SUCCESS'
export const WASHER_FAILURE = 'WASHER_FAILURE'

export const washerData = (washer) =>{
    return (dispatch, getState) => {
        dispatch({ type: WASHER_SUCCESS, washer });
    }
}